import { Button } from "primereact/button";
import { useContext, useState } from "react";
import { TopikTestContext } from "./TakeTest";
import testAnswerFalse from "../../../stories/assets/test-answer-false.svg";
import testAnswerTrue from "../../../stories/assets/test-answer-true.svg";

export default function AnswerSheet({ questions, isSubmitted }) {
  const { selectedAnswer, onSelectAnswer, translation } = useContext(TopikTestContext);
  const [collapsedSheet, setCollapsedSheet] = useState(false);

  const isSelectButton = (answer) => {
    return selectedAnswer[answer.questionId] === answer.id || answer.userSelect ? "bg-surfaces-black-bg text-white" : "bg-buttons-system-transparent text-default-txt-color";
  };

  const renderAnswerResultStatus = (answers, correctIndex) => {
    if (!isSubmitted || answers?.length === 0 || correctIndex == null) return null;
    const isUserSelectCorrectAnswer = answers.some((answer, index) => {
      return correctIndex === index && answer.userSelect;
    });

    return isUserSelectCorrectAnswer ? (
      <img className="topik-doing-test-answer-sheet-content-item-answer-status-true" src={testAnswerTrue} alt="" />
    ) : (
      <img className="topik-doing-test-answer-sheet-content-item-answer-status-wrong" src={testAnswerFalse} alt="" />
    );
  };

  return (
    <div className={`topik-doing-test-answer-sheet ${collapsedSheet ? "collapsed" : ""}`}>
      <div className={`topik-doing-test-answer-sheet-collapse-btn ${collapsedSheet ? "rotate-180" : ""}`} onClick={() => setCollapsedSheet((prevState) => !prevState)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
          <path d="M12 10L1.99998 20L0.599976 18.6L9.19998 10L0.599976 1.4L1.99998 0L12 10Z" fill="white" />
        </svg>
      </div>
      <div className="py-12px bg-surfaces-hover-bg w-full text-center">
        <h4 className="keduall-typography heading-h4-semibold-600">{translation?.answerSheetTitle}</h4>
      </div>
      <div className="topik-doing-test-answer-sheet-content">
        {questions.map((item, index) => {
          return (
            <div key={index} className="topik-doing-test-answer-sheet-content-item grid">
              <div className="relative col-2">
                <h6 className={`keduall-typography heading-h6-normal-400`}>{index + 1}.</h6>
                <div>{renderAnswerResultStatus(item.answers, item?.correctAnswerIndex)}</div>
              </div>
              <div className="col-10 flex gap-2 flex-wrap p-0 align-items-center">
                {item.answers.map((answer, index) => {
                  return (
                    <Button
                      key={index}
                      label={index + 1}
                      onClick={() => {
                        onSelectAnswer({
                          answerId: answer.id,
                          questionId: answer.questionId,
                        });
                      }}
                      rounded
                      severity="secondary"
                      className={`answer-sheet-question-button ${isSelectButton(answer)}`}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
